import { ISlide } from './ISlide';
import { SLIDE_FOLDER } from './Settings';

const showdown  = require('showdown');
export class Slide implements ISlide {
  public loaded: boolean;
  private _content: string;
  constructor(private readonly file: string) {
    const options = showdown.getDefaultOptions();
    options.excludeTrailingPunctuationFromURLs = true;
    options.openLinksInNewWindow = true;
    options.simplifiedAutoLink = true;
    options.strikethrough = true;
    options.tables = true;
    options.tasklists = true;
    options.underline = true;

    fetch(SLIDE_FOLDER + '/' + file)
      .then((response) => response.text())
      .then((data) => {
        const converter = new showdown.Converter(options);
        this._content = converter.makeHtml(data);
        this.loaded = true;
      });
  }

  public get content(): string {
    if (!this._content) {
      return '';
    }
    const dir = this.file.replace(/\/[^\/]+/, '');
    return this._content.replace(/src="(?!.*:\/\/)((?:[^"])*)"/g, 'src="' + SLIDE_FOLDER + '/' + this.file + '/../$1"');
  }
}
